import { __assign, __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { getValidatedResources } from '../utils';
import { mapToDataResidencySlim } from '../utils/helpers';
import { BaseMessageHandler } from './base-message-handler';
import { formulateAppMessageResult } from './messageHandlingUtils';
/**
 * Responsible for handling authentication related message requests.
 */
var BaseAuthenticationMessageHandler = /** @class */ (function (_super) {
    __extends(BaseAuthenticationMessageHandler, _super);
    function BaseAuthenticationMessageHandler(appSdkHost, authenticationService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.authenticationService = authenticationService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    BaseAuthenticationMessageHandler.prototype.initHandlers = function () {
        this.registerHandler(SdkMessageTypes.authentication.getUser, this.handleGetUser, {
            errorCallback: this.onGetUserError,
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.authentication.getAuthToken, this.handleGetAuthToken, {
            errorCallback: this.onGetAuthTokenError,
        });
    };
    BaseAuthenticationMessageHandler.prototype.validateDependencies = function () {
        if (!this.authenticationService) {
            throw 'No authentication service is available';
        }
    };
    /**
     * Request user profile for 1st-Party hosted experiences
     */
    BaseAuthenticationMessageHandler.prototype.handleGetUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, appContext, userProfile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticationService.getUser()];
                    case 1:
                        user = _a.sent();
                        if (!user) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.appSdkHost.getAppContext()];
                    case 2:
                        appContext = _a.sent();
                        userProfile = __assign(__assign({}, user.profile), { dataResidency: mapToDataResidencySlim(appContext.user.dataResidency) });
                        return [2 /*return*/, formulateAppMessageResult([true, userProfile])];
                    case 3: return [2 /*return*/, Promise.reject('Failed to fetch the user profile')];
                }
            });
        });
    };
    BaseAuthenticationMessageHandler.prototype.onGetUserError = function (error, scenario) {
        scenario === null || scenario === void 0 ? void 0 : scenario.fail("GetUser failed ".concat(error));
        return formulateAppMessageResult([false, error]);
    };
    /**
     * Request authentication token(s) for 1st-Party hosted experiences
     */
    BaseAuthenticationMessageHandler.prototype.handleGetAuthToken = function (_event, resources, claims, silent) {
        return __awaiter(this, void 0, void 0, function () {
            var appContext, validatedResources, authenticationToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.appSdkHost.getAppContext()];
                    case 1:
                        appContext = _a.sent();
                        return [4 /*yield*/, getValidatedResources(_event.origin, resources, this.appSdkHost.getHubInfo(), this.appDefinition, appContext)];
                    case 2:
                        validatedResources = _a.sent();
                        return [4 /*yield*/, this.authenticationService.acquireToken(validatedResources[0], claims, silent)];
                    case 3:
                        authenticationToken = _a.sent();
                        return [2 /*return*/, formulateAppMessageResult([true, authenticationToken.token])];
                }
            });
        });
    };
    BaseAuthenticationMessageHandler.prototype.onGetAuthTokenError = function (error, scenario) {
        scenario === null || scenario === void 0 ? void 0 : scenario.fail("GetAuthToken failed ".concat(error));
        return formulateAppMessageResult([false, error]);
    };
    return BaseAuthenticationMessageHandler;
}(BaseMessageHandler));
export { BaseAuthenticationMessageHandler };
//# sourceMappingURL=base-auth-message-handler.js.map